import { useTableColumns } from '../../../../hooks/table/useTableColumns/useTableColumns';
import { useTableColumnWithFiltersAndSorters } from '../../../../hooks/useTableColumnWithFiltersAndSorters/useTableColumnWithFiltersAndSorters';
import { createPatientColumns } from '../../../patient/component/PatientsTableComponent/columns';
import { PatientsTableComponent } from '../../../patient/component/PatientsTableComponent/PatientsTableComponent';
import { PatientTableProps } from '../../type';

export interface UnenrolledPatientsTableComponentProps extends PatientTableProps {
}

export const UnenrolledPatientsTableComponent = ({
  totalSize,
  filters,
  sorters,
  ...props
}: UnenrolledPatientsTableComponentProps) => {
  const columns = useTableColumns(
    createPatientColumns,
    ['name', 'age', 'gender', 'clinic', 'provider', 'mrn', 'registrationDate', 'dischargedDate'],
  );

  const columnsWithFilters = useTableColumnWithFiltersAndSorters({
    columns,
    filters,
    sorters: sorters || { columnKey: 'registrationDate', order: 'descend' },
  });

  return (
    <PatientsTableComponent
      totalSize={totalSize}
      columns={columnsWithFilters}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};
